import React from "react";
const MapSection = () => <section>hey i'm MapSection</section>;
export default MapSection;
